import { gql } from '@apollo/client';

export const userIdentityQuery = gql`
  query userIdentity {
    currentUser {
      id
      firstName
      lastName
      email
      isAdmin
      isRescuePartner
      isVerizonCustomer
      hasPurchasedSupplementSubscription
      previouslyPurchasedCollarProductIds
      decagonWidgetAuth {
        signature
        epoch
      }
      billingAccount {
        billingInfo {
          firstName
          lastName
          address {
            line1
            line2
            city
            state
            zip
            country
          }
        }
        address {
          line1
          line2
          city
          state
          zip
          country
          phone
        }
      }
    }
  }
`;

export const userFreeTrialStatusQuery = gql`
  query userFreeTrialStatus {
    currentUser {
      id
      userHouseholds {
        household {
          pets {
            device {
              hasActiveSubscription
              subscription {
                hasFreeTrialPlan
              }
            }
          }
        }
      }
    }
  }
`;

export const userPetsQuery = gql`
  query userPets {
    currentUser {
      id
      userHouseholds {
        household {
          pets {
            id
            name
            weight
            photos {
              first {
                image {
                  fullSize
                }
              }
            }
            device {
              moduleId
              subscription {
                id
                unitAmountInCents
              }
            }
          }
        }
      }
    }
  }
`;

export const userPetsIdQuery = gql`
  query userPetsId {
    currentUser {
      userHouseholds {
        household {
          pets {
            id
          }
        }
      }
    }
  }
`;

export const userPetsWeightQuery = gql`
  query userPetsWeight {
    currentUser {
      id
      userHouseholds {
        household {
          pets {
            weight
          }
        }
      }
    }
  }
`;

export const userThirdPartiesQuery = gql`
  query userThirdParties {
    currentUser {
      id
      email
      thirdPartyData {
        thirdPartyId
        data {
          nextBillDate
          subscriptionId
        }
      }
    }
  }
`;
